import request from '@/common/request'

const basePath = '/credito-informado'

export interface ConsultaCreditoInformadoResponse {
	integracaoConfigurada: boolean
	consultaIndisponivel: boolean
	bloqueado: boolean
	motivosBloqueio: string[]
	limiteInformado: number
	disponivelInformado: number
}

export const consultar = async (cnpjOuCpfCliente: string, lojaId: string): Promise<ConsultaCreditoInformadoResponse> =>
	request.post(`${basePath}/consulta?cnpjOuCpfCliente=${cnpjOuCpfCliente}&lojaId=${lojaId}`)
